import { kycServiceInstance } from './kyc.service.instance';
import {
  KYC_API_VERSION_HEADER,
  KYC_API_VERSION_V2,
  type IGetBlockedDomainResponse,
  type IGetKYCVerificationResponse,
  type IPostDocumentRequestPayload,
  type IPostDocumentRequestResponse,
  type IPostKycVerifyPayload,
} from './kyc.interface';

export const postKycVerify = async (payload: IPostKycVerifyPayload) => {
  const response = await kycServiceInstance.post<IGetKYCVerificationResponse>(
    '/verification',
    payload
  );
  return response.data;
};

export const getKycVerify = async () => {
  const response = await kycServiceInstance.get<IGetKYCVerificationResponse>('/verification');
  return response.data;
};

// Polls the DocV result endpoint (V2). Unlike GET /verification (a passive read of
// the stored status), this resolves the IDComply decision live and persists it —
// mirroring the mobile app. The V2 header is required: the path is shared with a V1
// handler and is version-neutral without it. Sent per-call so /verification and
// /documents/request on the shared instance stay version-neutral.
export const getDocumentsResultV2 = async (docvTransactionToken: string) => {
  // Encode the token before interpolating it into the path so a malformed value
  // (from tampered storage) can't reshape the request URL or traverse the path.
  const response = await kycServiceInstance.get<IGetKYCVerificationResponse>(
    `/documents/${encodeURIComponent(docvTransactionToken)}/result`,
    { headers: { [KYC_API_VERSION_HEADER]: KYC_API_VERSION_V2 } }
  );
  return response.data;
};

export const postKycDocumentRequest = async (payload?: IPostDocumentRequestPayload) => {
  const response = await kycServiceInstance.post<IPostDocumentRequestResponse>(
    '/documents/request',
    payload
  );
  return response.data;
};

export const getBlockedDomain = async (email: string) => {
  const response = await kycServiceInstance.get<IGetBlockedDomainResponse>(
    `/blocked-domain/${email}`
  );
  return response.data;
};
